// extracted by mini-css-extract-plugin
export var askAiIcon = "_pa-9";
export var container = "_pa-0";
export var groupSeparator = "_pa-a";
export var highlight = "_pa-4";
export var resultIcon = "_pa-5";
export var resultItem = "_pa-7";
export var resultSubtitle = "_pa-3";
export var resultTitle = "_pa-2";
export var resultsList = "_pa-1";
export var searchGroup = "_pa-6";
export var selected = "_pa-8";